/**
 * @generated SignedSource<<35bf4ea9d7aef8d27afeba5440da3f1f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceMetadataEditButtonFragment$data = {
  readonly id: string;
  readonly license: string | null | undefined;
  readonly shortDescription: string | null | undefined;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"TagListFragment" | "taggableFragment">;
  readonly " $fragmentType": "WorkspaceMetadataEditButtonFragment";
};
export type WorkspaceMetadataEditButtonFragment$key = {
  readonly " $data"?: WorkspaceMetadataEditButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceMetadataEditButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceMetadataEditButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "license",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TagListFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "taggableFragment"
    },
    {
      "alias": "viewerCanEdit",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_WORKSPACE"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_WORKSPACE\")"
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};

(node as any).hash = "77c93d134a9724b2176fd23a9c346ae5";

export default node;
